







































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SpeedTable extends Vue {
  // Props
  @Prop(Array) public speeds!: object[];
  @Prop(Number) public roadTracks!: number;
  @Prop(Boolean) public isReadOnly!: boolean;

  public speedHeaders = [
    'A1',
    'T1',
    'A2',
    'T2',
    'A3',
    'T3',
    'A4',
    'T4',
    'A5',
    'T5',
    'A6',
    'T6',
    'A7',
    'B7',
    'A8',
    'B8'
  ];
}
